import { useState } from "react";
import GetIcon from "../../../../utils/Icon";
import GeneralDetails from "./GeneralDetails";
import TaxDetails from "./TaxDetails";
import RegistrationDetails from "./RegistrationDetails";
import printerimg from "../../../../assets/print.png";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import Button from "../../../../Core/Button/Button";
import FormLayoutTwo from "../../../../Core/Layout/FormLayoutTwo";
import { usePostCreateCompanyMutation } from "../../../../store/api/companyapi";
import { useNavigate } from "react-router-dom";
import { usePageState } from "../../../../Hook/usePageState";
const CompanyForm = () => {
  const nvg = useNavigate();
  const [activeTab, setActiveTab] = useState(1);
  const [CreateCompany] = usePostCreateCompanyMutation();
  const [isSubmitting, setIsSubmitting] = useState(false); 
  

  const [fieldErrors, setFieldErrors] = useState({
    companyName: false,
    abbreviation: false,
    defaultCurrency: false,
  });

  const [apiResponse, setApiResponse] = useState({
    show: false,
    type: 'error',
    message: ''
  });



  const validateForm = () => {
    const errors = {};
    let isValid = true;
    
    setFieldErrors(errors);
    return isValid;
  };


    const pageStateDefault = {
      tab: 1,
       companyName: '',
    abbreviation: '',
    defaultCurrency: '',
    country: '',
    defaultGSTRate: '',
    defaultHolidayList: '',
    defaultLetterHead: '',
    domain: '',
    taxID: '',
    dateOfEstablishment: '',
    parentCompany: '',
    gstinUin: '',
    pan: '',
    gstCategory: '',
    registrationDetails: '',
    isgroup: false,
  
    };
  
    const [pageState, setPageState] = usePageState(`Create Company`, pageStateDefault);
  
  
    const { tab,companyName,abbreviation,defaultCurrency,country,defaultGSTRate,defaultHolidayList,defaultLetterHead,domain,taxID,dateOfEstablishment,parentCompany,gstinUin,pan,gstCategory,registrationDetails,isgroup} = pageState;
  
  
const handleSubmit = async () => {
  const requiredFields = ['companyName', 'abbreviation', 'defaultCurrency'];
  const newErrors = {};

  // Validate required fields
  requiredFields.forEach(field => {
    if (!pageState[field]?.trim()) {
      newErrors[field] = true;
    }
  });

  setFieldErrors(newErrors);

  if (Object.keys(newErrors).length > 0) {
    setApiResponse({
      show: true,
      type: 'error',
      message: 'Please fill all the required fields.'
    });
    return;
  }

  setIsSubmitting(true);

  try {
    const payload = {
      company_name: pageState.companyName,
      abbr: pageState.abbreviation,
      default_currency: pageState.defaultCurrency || '',
      country: pageState.country || '',
      default_gst_rate: pageState.defaultGSTRate || '',
      domain: pageState.domain || '',
      default_holiday_list: pageState.defaultHolidayList || '',
      default_letter_head: pageState.defaultLetterHead || '',
      tax_id: pageState.taxID || '',
      date_of_establishment: pageState.dateOfEstablishment || '',
      parent_company: pageState.parentCompany || '',
      gstin: pageState.gstinUin || '',
      pan: pageState.pan || '',
      gst_category: pageState.gstCategory || '',
      registration_details: pageState.registrationDetails || '',
      is_group: pageState.isgroup || false,
    };

    const response = await CreateCompany(payload);

    if (response.error) {
      const errorData = response.error.data || {};
      let messages = [];

      if (errorData._error_message) messages.push(errorData._error_message);

      if (errorData._server_messages) {
        try {
          const serverMsgs = JSON.parse(errorData._server_messages);
          serverMsgs.forEach(msgStr => {
            const parsed = JSON.parse(msgStr);
            if (parsed.message) messages.push(parsed.message);
          });
        } catch (e) {
          messages.push(errorData._server_messages);
        }
      }

      if (errorData.exception && !messages.includes(errorData.exception)) {
        messages.push(errorData.exception);
      }

      const finalMessage = messages
        .map(msg => msg.replace(/<[^>]+>/g, '').trim())
        .filter(Boolean)
        .join("\n");

      setApiResponse({
        show: true,
        type: 'error',
        message: finalMessage || "Something went wrong"
      });
      return;
    }

    setApiResponse({
      show: true,
      type: 'success',
      message: 'Company created successfully'
    });

    setTimeout(() => {
      nvg("/master/company/company-list");
    }, 1500);
  } catch (error) {
    setApiResponse({
      show: true,
      type: 'error',
      message: 'Failed to create company'
    });
  } finally {
    setIsSubmitting(false);
  }
};

const handleInputChange1 = (field, value) => {
  setPageState({ ...pageState, [field]: value });
};

  return (
    <>
      {/* Full-page loader overlay */}
      {isSubmitting && (
        <div className="loader-overlay">
          <div className="loader-spinner">
            <div className="spinner-border" style={{color:'#270b79'}} role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      )}

      <FormLayoutTwo
        title="New Company"
        breadcrumbs={[
          { label: "Company" },
          { label: "Company List", url: "/master/company/company-list" }
        ]}
        status={'hide'}
        actionButtons={
          <>
           
            <Button 
              className="custom-btn-00989"
              onClick={handleSubmit}
              iconName="LuFilePlus2"
              style={{gap:'2px',height:'28px'}}
              iconSize={12}
              disabled={isSubmitting} // Disable button during submission
            >
              {isSubmitting ? 'Saving...' : 'Save'}
            </Button>

            <Button 
              to="/" 
              className="px-2"
              imgSrc={printerimg}
              imgStyle={{ width: '21px' }}
            />
          </>
        }
      >
        <div className="" style={{ width: "100%", backgroundColor: "#fff" }}>
          <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
            <div className="d-flex justify-content-between align-items-end">
              <ul className="nav nav-tabs" style={{ color: "white", border: "none" }}>
                <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                  <a 
                    className={activeTab === 1 ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"} 
                    onClick={() => setPageState({ ...pageState, tab: 1 })}
                  >
                    General Details{activeTab === 1 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                  </a>
                </li>
              </ul>

              <div className="d-flex align-items-center mb-2 px-3" style={{ gap: "2px", fontSize: '12px' }}>
               <span style={{ position: "relative", top: "-1px" }}>
  <GetIcon className="text-[#4B002B]" iconName="CgAttachment" size={12} />
</span>
<span className="fw-semibold" style={{ color: "#4B002B" }}>
  Attachments
</span> 
              </div>
            </div>
          </div>

  <div className=" " style={{ background: '' }}>
                    <div className="row">
                      <div className="col-12">
                        <div >
                        <GeneralDetails
  pageState={pageState}
  handleChange={(f, v) => setPageState({ ...pageState, [f]: v })}
  onInputChange={(f, v) => setPageState({ ...pageState, [f]: v })}
  errors={fieldErrors}
/>



                {/* <TaxDetails 
                  formData={formData} 
                  handleChange={handleInputChange} 
                  errors={fieldErrors} 
                /> */}
                {/* <RegistrationDetails
                  formData={formData} 
                  handleChange={handleInputChange} 
                  errors={fieldErrors} 
                /> */}
                        </div>
                      </div>
                    </div>
                  </div> 
         
        </div>

        <ApiResponseBox
          poptype={apiResponse.type}
          show={apiResponse.show}
          errorMessage={apiResponse.message}
          onClose={() => setApiResponse(prev => ({...prev, show: false}))}
        />
      </FormLayoutTwo>
    </>
  );
};

export default CompanyForm;